const ConsCross = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clipPath="url(#clip0_141_16620)">
                <path
                    d="M15.0984 3.10039L12.8984 0.900391L7.99844 5.90039L3.09844 0.900391L0.898438 3.10039L5.89844 8.00039L0.898438 12.9004L3.09844 15.1004L7.99844 10.1004L12.8984 15.1004L15.0984 12.9004L10.0984 8.00039L15.0984 3.10039Z"
                    fill="#D2152D"
                />
            </g>
            <defs>
                <clipPath id="clip0_141_16620">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ConsCross;
